module.exports = __webpack_public_path__ + "assets/img/millenium-evo.28bbdea2.png";